module.exports = __webpack_public_path__ + "media/images/athletes/1659-fe82edef5d6fdd3afba3ec8dd219fa04.png";